import { AnalyticPrefix } from '@/enums/analytic-prefix-release';
import { Repository } from '@/enums/repos';

export default class Constants {
  static DS_REPOS = [
    Repository.HARVEST_PIXEL_BASED,
    Repository.SUGARCONTENT_YIELD_BRAZIL,
    Repository.SOIL_MOISTURE,
    Repository.NDVI_FUSION_ANALYTIC,
    Repository.SOWING_SUGARCANE,
    Repository.DEEP_LEARNING,
    Repository.LAND_USE,
    Repository.SAT_PIXEL_ANOMALY
  ];

  static DS_REPO_MULTIDOCKER = [Repository.DEEP_LEARNING];

  static DS_REPO_ANALYTIC_MAP = {
    [Repository.DEEP_LEARNING]: AnalyticPrefix.WEEDS
  };

  static DS_REPO_LABELS = {
    [Repository.HARVEST_PIXEL_BASED]: 'harvest, deforestation',
    [Repository.SUGARCONTENT_YIELD_BRAZIL]: 'sugar',
    [Repository.SOIL_MOISTURE]: 'soil-moisture',
    [Repository.NDVI_FUSION_ANALYTIC]: 'ndvi',
    [Repository.SOWING_SUGARCANE]: 'sowing',
    [Repository.DEEP_LEARNING]: 'weeds',
    [Repository.LAND_USE]: 'land-use',
    [Repository.SAT_PIXEL_ANOMALY]: 'pixel-anomaly'
  };
}
